"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 2 3.6903 2.0456-.9806 1.7179L13 4.8157v2.7496h-2V4.8157l-1.722.9546-.9806-1.7178L12 2zm5.9603 5.5653-1.6506-.9149.9806-1.7178L21 6.989v4.1241h-2V9.2504l-2.5097 1.3912-.9806-1.7179 2.4506-1.3584zM5 9.2503v1.8628H3V6.989l3.7097-2.0564.9806 1.7178-1.6506.915 2.4506 1.3583-.9806 1.7179L5 9.2504zm6 3.3261-1.8903-1.0479.9806-1.7178L12 10.8693l1.9097-1.0586.9806 1.7178L13 12.5763v1.641h-2v-1.6409zm-6 2.1732v-1.8627H3v4.1241l3.7097 2.0564.9806-1.7178-1.6506-.9149 2.4506-1.3585-.9806-1.7178L5 14.7496zm14 0v-1.8627h2v4.1241l-3.7097 2.0564-.9806-1.7178 1.6506-.9149-2.4506-1.3585.9806-1.7178L19 14.7496zm-8 4.4347v-2.7496h2v2.7496l1.7097-.9478.9806 1.7179L12 22l-3.6803-2.0401.9805-1.7178L11 19.1843z"
  })];
};

exports.default = _default;